import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router';

import { DEFAULT_RETRY_DELAY, DEFAULT_RETRY_NUMBERS } from '../../../config/query-client';
import type { IPersonalInfo } from './types';

export default function usePersonalInfoService(patientUuid?: string) {
  const { patientUuid: routePatientUuid = '' } = useParams<{
    patientUuid: string;
  }>();
  const resolvedPatientUuid = patientUuid ?? routePatientUuid;

  const result = useQuery<IPersonalInfo>({
    queryKey: ['camel', 'patient_profile', 'personal_info', resolvedPatientUuid],
    retry: DEFAULT_RETRY_NUMBERS,
    retryDelay: DEFAULT_RETRY_DELAY,
    enabled: !!resolvedPatientUuid,
  });

  const updateAction = useMutation({
    mutationFn: async ({ data, uuid }: { data: Partial<IPersonalInfo>; uuid: string }) => {
      await axios.put(`/api/camel/patient_profile/personal_info/${uuid}`, data);
      result.refetch();
    },
  });

  return {
    data: result?.data ?? ({} as IPersonalInfo),
    isLoading: !!resolvedPatientUuid && result.isLoading,
    updatePersonalInfo: updateAction.mutateAsync,
    isError: result?.isError ?? false,
  };
}
